import { render } from "./SchoolServiceCreateContainer.vue?vue&type=template&id=0f3559fd&ts=true"
import script from "./SchoolServiceCreateContainer.vue?vue&type=script&lang=ts"
export * from "./SchoolServiceCreateContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__